import { RegionShared } from "@1games-ru/region-shared";
import { VitalType } from "@1games-ru/region-shared/dist/enums/effect/effect";
import { VitalDto } from "@1games-ru/region-shared/dist/types/player/player";
import clsx from "clsx";
import { imgAvatar } from "@/shared/assets/img";
import InventoryCloseButton from "@/domains/inventory/components/InventoryCloseButton";
import InventoryCharacterVital from "@/domains/inventory/components/character/InventoryCharacterVital";

type Props = {
  player: typeof RegionShared.Client.Responses.GetPlayerResponse;
  onClose: () => Promise<void> | void;
};

export default function InventoryCharacterHeader({ player, onClose }: Props) {
  return (
    <div
      className={clsx(
        "rounded-b-[1rem] px-7.5 h-[4.875rem] w-full",
        "flex items-center justify-between gap-1.5 bg-gradient-to-r from-[#D73434]/30 via-transparent to-dark-800/60",
      )}
    >
      <div className="flex items-center gap-3">
        <div className="flex items-center justify-center border border-accent-solid rounded-[0.625rem] w-[2.75rem] h-[2.75rem] shrink-0">
          <img src={imgAvatar} alt="" className="w-[2.5rem] h-[2.5rem] rounded-[0.5rem]" />
        </div>
        <div className="flex flex-col">
          <div className="text-18 font-bold">{player?.character?.name.content}</div>
          <div className="text-14 text-accent-solid font-medium">#{player?.character?.id}</div>
        </div>
      </div>
      <div className="flex items-center gap-1.5">
        {(
          Object.entries(player?.character?.vitals || []) as unknown as [
            VitalType,
            VitalDto[keyof VitalDto],
          ][]
        ).map(([key, value]) => (
          <InventoryCharacterVital key={key} type={key} data={value} />
        ))}
        <InventoryCloseButton onClick={onClose} />
      </div>
    </div>
  );
}
